import { BaseResponse } from '../../../../../../../types/api/api.types';
import { COMMERCIAL_ENDPOINTS } from '../../../../../../../utils/api/endpoints/commercialEndpoints';
import { DashboardCommerciauxFormSchema } from './DashboardCommerciauxForm.types';

const PREFIX = '[createCommercialQuery]';

export const CREATE_COMMERCIAL_QUERY_KEY = 'CREATE_COMMERCIAL';

export const createCommercialQuery = async (data: DashboardCommerciauxFormSchema) => {
  console.log(PREFIX, `Requesting commercial account creation...`);
  const response = await COMMERCIAL_ENDPOINTS.create(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commercial account creation.`);
  return json as BaseResponse;
};
